import { getRootAppWindow } from "meta/utils/getRootAppWindow";
// TODO this function has side effects and affects the global scope
// retrieval of the data and modification of the global scope should be separated
// modification should be done in an extension file (or removed, see below), while the retrieval can stay here
// Justification for <any>: We do have the global window object typescript definition,
// where we could add a type definition for JSON_PARAMS, but I'd like to pollute the global scope the least as possible.
// As there aren't many direct references, I'd rather keep the access via this module rather than the global variable
// and possibly remove it in the future. There aren't many usages of it.
export const setDataGlobal = function (window) {
    if (!window.JSON_PARAMS)
        window.JSON_PARAMS = {};
    const windowWithParams = window;
    let parentDataScripts = getRootAppWindow(window).document.querySelectorAll('script[type="application/json"]');
    for (let i = 0; i < parentDataScripts.length; i++) {
        let s = parentDataScripts[i];
        parseDataScriptElement(windowWithParams, s);
    }
    let dataScripts = window.document.querySelectorAll('script[type="application/json"]');
    for (let i = 0; i < dataScripts.length; i++) {
        let s = dataScripts[i];
        parseDataScriptElement(windowWithParams, s);
    }
    return windowWithParams;
};
const parseDataScriptElement = function (window, element) {
    let data = JSON.parse(element.innerHTML);
    if (data) {
        if (element.id) {
            window.JSON_PARAMS = {
                ...window.JSON_PARAMS,
                [element.id]: data
            };
        }
        else {
            try {
                window.JSON_PARAMS = {
                    ...window.JSON_PARAMS,
                    ...data
                };
            }
            catch (e) {
                debugger;
            }
        }
    }
};
export function getJsonParamsForWindow(win) {
    return setDataGlobal(win).JSON_PARAMS;
}
let params = setDataGlobal(window).JSON_PARAMS;
export default params;
